import { render, staticRenderFns } from "./CreateUserRoute.vue?vue&type=template&id=6e58bb10&scoped=true&"
import script from "./CreateUserRoute.vue?vue&type=script&lang=js&"
export * from "./CreateUserRoute.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserRoute.vue?vue&type=style&index=0&id=6e58bb10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e58bb10",
  null
  
)

export default component.exports